import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { MenuItemStore } from './menu-item.store';

@Injectable({
    providedIn: 'root'
})
export class MenuItemQuery extends BaseQuery {

    constructor(store: MenuItemStore) {
        super(store);
    }


}
